import React, { Dispatch, SetStateAction } from 'react';

import { VehicleDetails } from 'Utilities/profiling/@types';

import { VehicleImages } from './confirmSale/DataList/DataList.types';
import type { Document, State } from './DocumentCapture.helpers';
import { ConfirmSaleAllowedStatusesValue, DocumentCaptureReviewCompleteAllowedStatesValue, SaleConfirmedStatusesValue, viewTimelineStatusesValue } from './DocumentCapture.types';

export interface Valuation {
  buyerId?: number;
  createdAt?: Date;
  deepLink?: string;
  enquiryId?: number;
  // eslint-disable-next-line camelcase
  estimated_price?: number;
  id?: number;
  responseTime?: number;
  status?: string;
  updatedAt?: Date;
  valuation?: number;
  // eslint-disable-next-line camelcase
  valuation_ref?: string;
  // eslint-disable-next-line camelcase
  vehicle_ref?: null;
}

// TODO: improve typing
export type DocumentCaptureOfferContextType = {
  acceptedBid?: {
    dealer?: {
      name?: string;
      termsOfSale?: string;
    };
    value?: number;
  };
  closingBid?: {
    id?: number;
    value?: number;
  };
  data?: {
    // eslint-disable-next-line camelcase
    basic_details?: {
      keepPrivatePlate?: boolean;
      mileage?: number;
      privatePlate?: boolean;
    };
    finance?:{
      isVehicleOnFinance?: boolean;
      settlementFigure?: string;
      settlementFigureOption?: number;
    };
    seller?: {
      Mobile: string;
      PostCode: string;
      address1: string;
      address2: string;
      address3: string;
      keeperType: VehicleDetails['keeperType'];
      town: string;
    };
  };
  enquiryId?: number;
  features?: {
    DOCUMENTS_PROGRESSIVE_UPLOAD?: boolean;
    SELLER_REENTRY?: boolean;
    documentCaptureV2?: boolean;
    paymentsMVP?: boolean;
    sellerBankStatement?: boolean;
  };
  id?: number;
  premiumOffer?: { id: undefined | number };
  state?: {
    slug?:
    | ConfirmSaleAllowedStatusesValue
    | SaleConfirmedStatusesValue
    | viewTimelineStatusesValue
    | DocumentCaptureReviewCompleteAllowedStatesValue;
  };
  valuation?: Valuation;
  vehicleImages?: VehicleImages[];
} & State;

const documentCaptureOfferState: DocumentCaptureOfferContextType = {};

export const DocumentCaptureOfferContext = React.createContext(documentCaptureOfferState);
DocumentCaptureOfferContext.displayName = 'DocumentCaptureOfferContext';

// TODO: improve typing
export type DocumentCaptureConfirmationProgressContextType = {
  progress: {
    bankDetailsAdded?: boolean;
    bankDetailsReviewFailed?: boolean;
    confirmedBySeller?: boolean;
    documents?: Document[];
    documentsFulfilled?: boolean;
  };
  setProgress?: Dispatch<SetStateAction<DocumentCaptureConfirmationProgressContextType['progress']>>;
}

const documentCaptureConfirmationProgressState: DocumentCaptureConfirmationProgressContextType = {
  progress: {},
};

export const DocumentCaptureConfirmationProgressContext = React.createContext(documentCaptureConfirmationProgressState);

export type FinanceSettlementDetails = {
  documentLocation?: string;
  expiry?: string;
  figure?: string;
}

export type FinanceSettlementProviderContextType = {
  financeAgreement: {
    automatedFinanceProvider?: string;
    failedLookupReason?: string;
    optedOut?: boolean;
    settlementDetails?: FinanceSettlementDetails;
  };
  isAutomatedDocumentUpload?: boolean;
  setFinanceAgreement?: Dispatch<SetStateAction<FinanceSettlementProviderContextType['financeAgreement']>>;
  setIsAutomatedDocumentUpload?: Dispatch<SetStateAction<FinanceSettlementProviderContextType['isAutomatedDocumentUpload']>>;
}

const financeSettlementProviderState: FinanceSettlementProviderContextType = {
  financeAgreement: {},
  isAutomatedDocumentUpload: false,
};

export const FinanceSettlementProviderContext = React.createContext(financeSettlementProviderState);
